// employee
const employeeUrl = '/app/employee'

export const getEmployeePage = () => `${employeeUrl}`
export const createEmployee = () => `${employeeUrl}`
export const updateEmployee = (id) => `${employeeUrl}/${id}`
export const deleteEmployee = (id) => `${employeeUrl}/${id}`
export const getEmployeeDictionary = (version) =>
  `${employeeUrl}/employee-dictionary?version=${version}`
export const lockEmployee = () => `${employeeUrl}/lock`
